import {BasketTotal} from "@irati/types"

interface DiscountAndFPCashback {
  discountValueInCents: number,
  discountValue: string,
  flexiPointsAmount: number
}

export const calculateDiscount = (discount?: BasketTotal, cashback?: BasketTotal): DiscountAndFPCashback => {
  const discountValueInCents = discount ? discount?.originalPrice - discount?.amount : 0
  const discountValue = discountValueInCents ? (discountValueInCents / 100).toFixed(2) : ""
  const flexiPointsAmount = cashback?.amount ? cashback?.amount / 100 : 0

  return {discountValueInCents, discountValue, flexiPointsAmount}
}
